import {default as Tree} from "./components/ProviderDnd"

export default Tree
